import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FormContainer from './components/FormContainer/FormContainer';
import { Page404 } from './components/ErrorPages/Errors';
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<FormContainer />} />
          <Route path="/:slug" element={<FormContainer />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
